import EmbedYoutube from 'components/embedYoutubeModal';
import { videoMetaData } from 'components/Withdraw/Withdraw.India/VideoTutorial';
import { noop } from 'helpers/utils';
import useToggle from 'hooks/useToggle';
import i18n from 'i18n/config';
import { NewYoutubeTutorialIcon } from 'styles/assets/icons';
import Box from 'UIKit/Box';
import IconButton from 'UIKit/IconButton';

import styles from './accountHeaderPartials.module.scss';

const withdrawalBankText = i18n.t<string>('account:sideNav.withdrawalBank');

const WithdrawalBankIndiaHeader = () => {
  const [videoPlay, toggleVideoPlay] = useToggle(false);

  return (
    <Box
      flex="flex"
      fullWidth
      gap={16}
      alignItems="center"
      className={styles.withdrawalHeader}
    >
      <Box as="span" autoMargin="both">
        {withdrawalBankText}
      </Box>
      <IconButton
        onKeyDown={noop}
        data-testid="how-to-withdraw-video-btn-mobile"
        onClick={toggleVideoPlay}
        className={styles.videoButton}
        icon={<NewYoutubeTutorialIcon />}
      />
      <EmbedYoutube
        src={videoMetaData.video}
        onClose={toggleVideoPlay}
        isOpen={videoPlay}
      />
    </Box>
  );
};

export { WithdrawalBankIndiaHeader };
